import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgxEzModalService} from '../../../../../../shared/modules/ngx-ez-modal/ngx-ez-modal.service';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-lol-character-select',
  templateUrl: './lol-character-select.component.html',
  styleUrls: ['./lol-character-select.component.scss']
})
export class LolCharacterSelectComponent implements OnInit {
  @Input() singleSelect: boolean;

  public characters: { name: string }[] = [];
  public availableCharacters: { name: string }[] = [];
  public currentSelectedCharacters: string[] = [];
  public availableCharactersSearchString = '';
  public currentSelectedRole: string;

  @Output() selected = new EventEmitter<string | string[]>();

  constructor(public modalService: NgxEzModalService, private http: HttpClient) {
  }

  ngOnInit(): void {
    this.http.get('/customer/available-characters/lol').subscribe((resp: any) => {
      this.characters = resp;
      this.availableCharacters = resp;
    });
  }

  filterCharacters(event) {
    this.availableCharactersSearchString = event.target.value;
    this.availableCharacters = this.characters.filter(el => el.name.toLowerCase()
      .indexOf(this.availableCharactersSearchString.toLowerCase()) > -1);
  }

  toggleCharacterSelection(character: string) {
    if (this.singleSelect) {
      this.selected.emit(character);
      this.modalService.closeOutletModals('public');
      return;
    }

    if (this.currentSelectedCharacters.indexOf(character) > -1) {
      this.currentSelectedCharacters = this.currentSelectedCharacters.filter(el => el !== character);
    } else {
      this.currentSelectedCharacters = [...this.currentSelectedCharacters, character];
    }
  }

  verifySelectedCharacters() {
    this.selected.emit(this.currentSelectedCharacters);
    this.modalService.closeOutletModals('public');
  }
}
